import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { SocialValidation } from './components/SocialValidation';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { CTASection } from './components/CTASection';
import { FAQSection } from './components/FAQSection';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ?
        // @ts-ignore
        n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      // @ts-ignore
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      // @ts-ignore
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      // @ts-ignore
      t.src = v;
      b.head.appendChild(t);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // @ts-ignore
    window.fbq('init', '28914431981489824');
    // @ts-ignore
    window.fbq('track', 'PageView');
    // @ts-ignore
    window.fbq('track', 'ViewContent');
  }, []);
  return <div className="min-h-screen bg-surface-deepest text-white font-body selection:bg-gold/30 selection:text-gold-light" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <SocialValidation data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <GuaranteeSection data-id="element-8" />
        <CTASection data-id="element-9" />
        <FAQSection data-id="element-10" />
      </main>
    </div>;
}